import { render, staticRenderFns } from "./AdvisorCoreFAQ.vue?vue&type=template&id=81942eca&scoped=true&"
import script from "./AdvisorCoreFAQ.vue?vue&type=script&lang=js&"
export * from "./AdvisorCoreFAQ.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81942eca",
  null
  
)

export default component.exports